import React, { useState } from 'react'
import './Header.css'
import { RiInstagramFill } from "react-icons/ri"
import { FaTiktok } from "react-icons/fa"
import { FaFacebookF } from "react-icons/fa"
import { FaYoutube } from "react-icons/fa"
import { RxHamburgerMenu } from 'react-icons/rx'
import { RxCross1 } from 'react-icons/rx'
import { IoChevronDown } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

function Header() {
  const [activeMenu, setActiveMenu] = useState('home')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const navigate = useNavigate()

  const handleSmoothScroll = (sectionId, menuItem) => {
    if (window.location.pathname !== '/') {
      navigate('/')
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    } else {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
    setActiveMenu(menuItem)
    setIsMenuOpen(false)
    setIsDropdownOpen(false)
  }

  const handleDropdownNavigation = (menuItem, path = '/teambuildings') => {
    setActiveMenu(menuItem)
    if (path.startsWith('#')) {
      // Handle smooth scroll for sections
      handleSmoothScroll(path.substring(1), menuItem)
    } else {
      // Handle navigation to pages
      navigate(path)
      setIsMenuOpen(false)
      setIsDropdownOpen(false)
    }
  }

  return (
    <div className="sub_section header">
      <picture className='logo' onClick={() => navigate('/')}>
        <source srcSet={require('../assets/logo_zwart_transparant.webp')} type="image/webp" />
        <img src={require('../assets/logo_zwart_transparant.png')} alt="Pole District 85 Logo" />
      </picture>
      <div className='menu desktop'>
        <a href="#" className={`menu_item ${activeMenu === 'home' ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setActiveMenu('home');
          }}>Home</a>
        <a href="#about-section" className={`menu_item ${activeMenu === 'over-ons' ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            handleSmoothScroll('about-section', 'over-ons')
          }}>Over Ons</a>
        <div className="dropdown-container"
          onMouseEnter={() => setIsDropdownOpen(true)}
          onMouseLeave={() => setIsDropdownOpen(false)}>
          <a href="#" 
            className={`menu_item dropdown-toggle ${['lessen', 'workshops', 'teambuildings', 'zaalverhuur'].includes(activeMenu) ? 'active' : ''}`}
            onClick={(e) => e.preventDefault()}>
            Aanbod <IoChevronDown className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />
          </a>
          <div className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
            <a href="#courses-section" 
              className="dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('lessen', '#courses-section')
              }}>Lessen</a>
            <a href="#" 
              className="dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('workshops')
              }}>Workshops</a>
            <a href="#" 
              className="dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('teambuildings')
              }}>Teambuildings</a>
            <a href="#" 
              className="dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('zaalverhuur')
              }}>Zaalverhuur</a>
          </div>
        </div>
        <a href="#" className={`menu_item ${activeMenu === 'uurrooster' ? 'active' : ''}`}
          onClick={() => {
            setActiveMenu('uurrooster')
            navigate('/classes')
          }}>Uurrooster</a>
        <a href="#" className={`menu_item ${activeMenu === 'prijzen' ? 'active' : ''}`}
          onClick={() => {
            setActiveMenu('prijzen')
            navigate('/prices')
          }}>Prijzen</a>
        <a href="#" className={`menu_item ${activeMenu === 'faq' ? 'active' : ''}`}
          onClick={() => {
            setActiveMenu('faq')
            navigate('/faq')
          }}>FAQ</a>
        <a href="#" 
          className={`menu_item ${activeMenu === 'contact' ? 'active' : ''}`} 
          onClick={() => {
            setActiveMenu('contact')
            navigate('/contact')
          }}>Contact</a>
        <a href="#" 
          className="book_button" 
          onClick={() => {
            setActiveMenu('book')
            navigate('/book')
          }}>Boek je les</a>
      </div>

      <div className='hamburger-icon mobile-only' onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <RxCross1 /> : <RxHamburgerMenu />}
      </div>

      <div className={`menu mobile ${isMenuOpen ? 'open' : ''}`}>
        <a href="#" className={`menu_item`}
          onClick={(e) => {
            e.preventDefault();
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setActiveMenu('home');
            setIsMenuOpen(false);
          }}>Home</a>        
        <a href="#about-section" className={`menu_item`}
            onClick={(e) => {
              e.preventDefault()
              handleSmoothScroll('about-section', 'over-ons')
            }}>Over Ons</a>
        <div className="mobile-dropdown-container">
          <a href="#" 
            className={`menu_item mobile-dropdown-toggle ${['lessen', 'workshops', 'teambuildings', 'zaalverhuur'].includes(activeMenu) ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault()
              setIsDropdownOpen(!isDropdownOpen)
            }}>
            Aanbod <IoChevronDown className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`} />
          </a>
          <div className={`mobile-dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
            <a href="#courses-section" 
              className="mobile-dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('lessen', '#courses-section')
              }}>Lessen</a>
            <a href="#" 
              className="mobile-dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('workshops')
              }}>Workshops</a>
            <a href="#" 
              className="mobile-dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('teambuildings')
              }}>Teambuildings</a>
            <a href="#" 
              className="mobile-dropdown-item" 
              onClick={(e) => {
                e.preventDefault()
                handleDropdownNavigation('zaalverhuur')
              }}>Zaalverhuur</a>
          </div>
        </div>
        <a href="#" className={`menu_item`}
          onClick={() => {
            setActiveMenu('uurrooster')
            navigate('/classes')
            setIsMenuOpen(false)
          }}>Uurrooster</a>
        <a href="#" className={`menu_item`}
          onClick={() => {
            setActiveMenu('prijzen')
            navigate('/prices')
            setIsMenuOpen(false)
          }}>Prijzen</a>
        <a href="#" className={`menu_item`}
          onClick={() => {
            setActiveMenu('faq')
            navigate('/faq')
            setIsMenuOpen(false)
          }}>FAQ</a>
        <a href="#" className={`menu_item`} 
          onClick={() => {
            setActiveMenu('contact')
            navigate('/contact')
            setIsMenuOpen(false)
          }}>Contact</a>
        <a href="#" 
          className="book_button" 
          onClick={() => {
            setActiveMenu('book')
            navigate('/book')
            setIsMenuOpen(false)
          }}>Boek je les</a>
      </div>
      <div className='socials'>
        <RiInstagramFill className='social_item' onClick={() => window.open('https://www.instagram.com/poledistrict85?igsh=cXkwcTR6emFkaXNi', '_blank')} />
        {/* <FaTiktok className='social_item' onClick={() => window.open('https://www.tiktok.com/@poledistrict85', '_blank')} />
        <FaFacebookF className='social_item' onClick={() => window.open('https://www.facebook.com/poledistrict85', '_blank')} />
        <FaYoutube className='social_item' onClick={() => window.open('https://www.youtube.com/@poledistrict85', '_blank')} /> */}
      </div>
    </div>
  )
}

export default Header